import React__default from 'react';

var ColHeaderBlock = function (_a) {
    var children = _a.children, colHeaderBlockRef = _a.colHeaderBlockRef, isIconBlock = _a.isIconBlock, isNeedSetOpacityClass = _a.isNeedSetOpacityClass;
    return (React__default.createElement("div", { ref: colHeaderBlockRef, className: "top-row-".concat(isIconBlock ? 'icon' : 'min-max', "-block ").concat(isNeedSetOpacityClass ? 'w-op-and-tr' : '') }, children));
};

export { ColHeaderBlock };
